import React from 'react'

import styles from './ModalCard.module.scss'
import LanguageRadioSelect from '../RadioSelect/LanguageRadioSelect'
import { H4 } from '../../../../components/UI'
import { ReactComponent as Close } from '../../../../assets/svgs/close.svg'
import I18n from 'i18n-js'



const LanguageModalCard = (props)=>{
	const {handleClose}=props
	return(
		<div>
			<div >
				<div className={styles.Header}>
					<p className={styles.title}>{I18n.t('settings.languageTitle')}</p>
					<div className={styles.close} onClick={handleClose}>
						<Close/>
					</div>
				</div>
				<H4>{I18n.t('settings.languageDescription')}</H4>
				<LanguageRadioSelect handleClose={handleClose}/>
			</div>
		</div>
	)
}

export default LanguageModalCard
